export const DESCRIPTIONS = {
  Sustainability: {
    optional: true,
  },
  'Physical Goods': {
    description:
      'We scour the planet to find products and vendors that we’d be comfortable putting in our homes and in our comprehensive catalog. This team also develops Grove’s own innovative products and brings them to market in exciting ways that resonate with customers.',
    teams: {
      Merchandising:
        'You can help us find the best natural products in the market and bring them to life on Grove.co',
      Inventory:
        'Be an expert partner with suppliers to make sure we have the right goods across our network',
    },
  },
  Operations: {
    description:
      'Our mission is to quickly and accurately deliver the best selection of high quality, eco-friendly products to the most important people at Grove, our consumers.',
    teams: {
      'Fulfillment and Inventory':
        'You can create moments of joy for our customers by receiving, picking, packing, and shipping products.',
      Management:
        'You can help us keep our fulfillment centers high-functioning while treating our associates well.',
    },
  },
  Finance: {
    description:
      'Our company is made strong by its people and we do our best to create an environment that makes work feel less like work.',
    teams: {
      Finance:
        'Join the team we rely on to keep the lights on, and the bills paid.',
      'Office and Facilities':
        'Help us keep our teams happy and our office functioning.',
      'People Experience':
        'Help us keep the team happy, productive and supported.',
    },
  },
  'Brand and Marketing': {
    description:
      'This team helps current customers get the most out of Grove, while also helping more and more new customers discover us every day.',
    teams: {
      'Creative and Brand':
        'You can help keep our brand consistent and beautiful by creating the photography and packaging for the Grove experience.',
      'Growth and Marketing':
        'Combine actionable data, beautiful creative, and amazing products to drive strong customer engagement.',
    },
  },
  'Community Happiness': {
    description:
      'Help customers anytime and anywhere — on phone, chat, email, or social media. Our on-site “Grove Guides” build trust with customers through timely and genuine responses.',
    teams: {},
  },
  'Engineering, Product, Design, and Analytics': {
    description:
      'This team is dedicated to making shopping at Grove.co easy and enjoyable for all.',
    teams: {
      Analytics:
        'You know how critical data is to driving teams to take action and get results.',
      'Product and Product Design':
        'Collaborate on our business strategy, user-centered design, and testing methodology.',
      Engineering:
        'You can help ship code every day for an e-commerce challenge.',
    },
  },
}

export const DEPARTMENTS = Object.keys(DESCRIPTIONS)

export function getDepartments(positions, options = {}) {
  const positionDepartments = positions.map(
    (position) => position.categories.department
  )

  const departments = options.showEmpty
    ? [...DEPARTMENTS, ...positionDepartments]
    : [...positionDepartments]

  const uniqueDepartments = Array.from(new Set(departments))

  return uniqueDepartments.filter((department) => {
    return (
      positionDepartments.includes(department) ||
      !DESCRIPTIONS[department].optional
    )
  })
}

export function getLocations(positions) {
  return Array.from(
    new Set(positions.map((position) => position.categories.location))
  )
}

export function filterPositions(positions, { department, location }) {
  return positions.filter((position) => {
    let result = true

    if (department) {
      result = position.categories.department === department
    }

    if (result && location) {
      result = position.categories.location === location
    }

    return result
  })
}

function groupPositions(positions, propName) {
  return positions.reduce((acc, position) => {
    const prop = position.categories[propName]

    if (!acc[prop]) {
      acc[prop] = []
    }

    acc[prop].push(position)

    return acc
  }, {})
}

export function groupPositionsByDepartment(positions) {
  return groupPositions(positions, 'department')
}

export function groupPositionsByLocation(positions) {
  return groupPositions(positions, 'location')
}

export function groupPositionsByTeam(positions) {
  return groupPositions(positions, 'team')
}
